import { render } from "./ResultsScreen.vue?vue&type=template&id=f6ade0f0&scoped=true"
import script from "./ResultsScreen.vue?vue&type=script&lang=js"
export * from "./ResultsScreen.vue?vue&type=script&lang=js"

import "./ResultsScreen.vue?vue&type=style&index=0&id=f6ade0f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ade0f0"]])

export default __exports__